"use strict";

window.addEventListener('DOMContentLoaded', function (event) {
  var pageNav = document.querySelector('.doctor-bio-masthead__nav-wrapper');
  //Fixed in-page navigation 
  if (pageNav) {
    var offsetBio = pageNav.offsetTop;
    var mediaQueryUnder = window.matchMedia('(max-width: 991px)');

    // Highlight active in-page links 
    var allJumpLinks = document.querySelectorAll('.doctor-bio-masthead__nav-wrapper ul li');
    allJumpLinks.forEach(function (link) {
      link.addEventListener("click", function (e) {
        e.preventDefault();
        allJumpLinks.forEach(function (link) {
          link.classList.remove("active");
        });
        this.classList.add("active");
      });
    });
    if (mediaQueryUnder.matches) {
      // Sticky mobile in-page nav
      window.addEventListener('scroll', function (event) {
        var scrollBio = window.scrollY;
        if (scrollBio >= offsetBio) {
          pageNav.classList.add("secondary-nav--stick");
        } else if (scrollBio <= offsetBio) {
          pageNav.classList.remove("secondary-nav--stick");
        }
      });
    }
  }
});